/**
 * Common MIME Types
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
 */

/**
 * Accepted mimetypes for music files
 */
export const music = {
  'audio/aac': ['.aac'],
  'audio/mpeg': ['.mp3'],
  'audio/mp4': ['.mp4'],
  'video/mp4': ['.mp4'],
};

/**
 * Accepted mimetypes for images
 */
export const images = {
  'image/bmp': ['.bmp'],
  'image/gif': ['.gif'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/svg+xml': ['.svg'],
  'image/tiff': ['.tif', '.tiff'],
  'image/webp': ['.webp'],
};

/**
 * Accepted mimetypes for attachments
 */
export const attachments = {
  'audio/mpeg': ['.mp3'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'text/plain': ['.txt'],
  'application/pdf': ['.pdf'],
  'application/msword': [],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
};

/**
 * Accepted mimetypes for display
 */
export const display = {
  'video/mp4': ['.mp4'],
  // 'image/jpeg': ['.jpg', '.jpeg'],
  // 'image/png': ['.png'],
};

export default {
  music,
  images,
  attachments,
  display,
};
